import template from './targetdrgs.html';
import controller from './targetdrgs.controller';
import './targetdrgs.styl';

let targetdrgsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default targetdrgsComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/targetdrgs/targetdrgs.component.js